import React from "react";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";
import { type BlockPresetImportT } from "../../../../../../schema/block/preset";
import { TableLine } from "@ui/IconV2/react";

export const icon = () => <TableLine size="l" color={colors.carbon800} />;

export const title = t("project.dashboard.block.template.priority-fault-events-preset.title");

export const description = null;

export const block: Omit<BlockPresetImportT, "dashboardId" | "position"> = {
  kind: "PRESET",
  data: {
    title,
    preset: "PRIORITY_FAULT_EVENTS",
    systemIds: [],
  },
};
